import { render } from "./ConversationDetails.vue?vue&type=template&id=d4b5ab0e&scoped=true"
import script from "./ConversationDetails.vue?vue&type=script&lang=js"
export * from "./ConversationDetails.vue?vue&type=script&lang=js"

import "./ConversationDetails.vue?vue&type=style&index=0&id=d4b5ab0e&lang=css"
import "./ConversationDetails.vue?vue&type=style&index=1&id=d4b5ab0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4b5ab0e"]])

export default __exports__